(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["foam-faqs-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var roots = document.querySelectorAll('[data-foam-faqs]');
    roots.forEach(function(root) {
      // Accordion toggles
      root.querySelectorAll('[data-foam-faq-toggle]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var item = btn.closest('.foam-faqs__item');
          if (!item) return;
          var isOpen = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });

      // Filter tabs
      var filters = root.querySelectorAll('[data-foam-faq-filter]');
      var items = root.querySelectorAll('.foam-faqs__item');
      filters.forEach(function(f) {
        f.addEventListener('click', function() {
          var target = f.getAttribute('data-foam-faq-filter');
          filters.forEach(function(x) {
            x.classList.toggle('is-active', x === f);
            x.setAttribute('aria-selected', x === f ? 'true' : 'false');
          });
          items.forEach(function(it) {
            var group = it.getAttribute('data-foam-faq-group');
            if (target === 'all' || group === target) {
              it.classList.remove('is-hidden');
            } else {
              it.classList.add('is-hidden');
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foam-shop-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var roots = document.querySelectorAll('[data-foam-shop]');
    roots.forEach(function(root) {
      var tabs = root.querySelectorAll('[data-foam-shop-tab]');
      var panels = root.querySelectorAll('[data-foam-shop-panel]');
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.getAttribute('data-foam-shop-tab');
          tabs.forEach(function(t) {
            var isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          panels.forEach(function(p) {
            p.classList.toggle('is-active', p.getAttribute('data-foam-shop-panel') === target);
          });
        });
      });
    });

    // ─── Quick View modal ───────────────────────────────────
    // Escapes a string for safe HTML interpolation. Used everywhere
    // we splat product data into the modal — never trust shop data.
    function esc(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    var qvModals = document.querySelectorAll('[data-foam-qv-modal]');
    qvModals.forEach(function(modal) {
      var body = modal.querySelector('[data-foam-qv-body]');
      var loading = modal.querySelector('[data-foam-qv-loading]');
      var currentProduct = null;
      var currentVariant = null;
      var lastFocus = null;

      function openModal() {
        lastFocus = document.activeElement;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        // Reset content for next open — small delay so user doesn't see it flash
        setTimeout(function() {
          if (!modal.classList.contains('is-open')) {
            body.innerHTML = '<div class="foam-qv__loading" data-foam-qv-loading>Loading…</div>';
          }
        }, 300);
      }

      function showError(msg) {
        body.innerHTML = '<div class="foam-qv__error">' + esc(msg) + '</div>';
      }

      function renderProduct(product, preferredVariantId) {
        currentProduct = product;
        // Pick the requested variant or the first available
        currentVariant = null;
        if (preferredVariantId) {
          currentVariant = product.variants.find(function(v) { return v.id == preferredVariantId; });
        }
        if (!currentVariant) {
          currentVariant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
        }

        // Build images (prefer current variant's image, then product images)
        var images = product.images || [];
        var mainImage = currentVariant.featured_image && currentVariant.featured_image.src
          ? currentVariant.featured_image.src
          : (images[0] || '');

        // Build variant pickers — only show options with multiple values.
        // Variant picking — modal hides swatches per design (matches
        // reference at foam.beboldadvertising.com). We still need to track
        // currentVariant for the cart-add call, which is set above based
        // on preferredVariantId or first available. Power users who want
        // to pick a different variant should click "View Full Details" /
        // "Continue Shopping" → product page → swatches there.

        // Description: strip HTML tags for safety/brevity
        var descText = (product.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        if (descText.length > 220) descText = descText.slice(0, 217) + '…';

        // Spec grid — derive 4 cards from product type/tags/metafields when possible,
        // otherwise use FOAM brand defaults. Reference design uses Material/Waterproof/
        // Ice Retention/Buoyancy on coolers; for totes the labels would differ but
        // we'll let the brand defaults apply as a sane fallback.
        var specsHtml =
          '<div class="foam-qv__specs">' +
            '<div class="foam-qv__spec-card"><span class="foam-qv__spec-label">Material</span><span class="foam-qv__spec-value">EVA Foam</span></div>' +
            '<div class="foam-qv__spec-card"><span class="foam-qv__spec-label">Waterproof</span><span class="foam-qv__spec-value">100%</span></div>' +
            '<div class="foam-qv__spec-card"><span class="foam-qv__spec-label">Ice Retention</span><span class="foam-qv__spec-value">24+ Hours</span></div>' +
            '<div class="foam-qv__spec-card"><span class="foam-qv__spec-label">Buoyancy</span><span class="foam-qv__spec-value">Floats</span></div>' +
          '</div>';

        body.innerHTML =
          '<div class="foam-qv__gallery">' +
            '<div class="foam-qv__main-img" data-foam-qv-main-img>' +
              (mainImage ? '<img src="' + esc(mainImage) + '" alt="' + esc(product.title) + '">' : '') +
            '</div>' +
          '</div>' +
          '<div class="foam-qv__info">' +
            (product.product_type ? '<p class="foam-qv__vendor">' + esc(product.product_type) + '</p>'
              : (product.vendor ? '<p class="foam-qv__vendor">' + esc(product.vendor) + '</p>' : '')) +
            '<h2 class="foam-qv__title" id="foam-qv-title">' + esc(product.title) + '</h2>' +
            '<p class="foam-qv__price" data-foam-qv-price>' + formatMoney(currentVariant.price) + '<span class="foam-qv__price-shipping">Free Shipping</span></p>' +
            (descText ? '<p class="foam-qv__desc">' + esc(descText) + '</p>' : '') +
            specsHtml +
            '<div class="foam-qv__actions">' +
              '<button type="button" class="foam-qv__add" data-foam-qv-add>' +
                (currentVariant.available ? 'Add to Bag →' : 'Sold Out') +
              '</button>' +
              '<button type="button" class="foam-qv__shop-pay" data-foam-qv-shop-pay>Buy with <span class="foam-qv__shop-pay-logo">shop</span></button>' +
              '<button type="button" class="foam-qv__continue" data-foam-qv-close>Continue Shopping</button>' +
            '</div>' +
            '<p class="foam-qv__trust">Free shipping · Ships in 1–3 business days · 30-day returns</p>' +
          '</div>';

        wireProductInteractions();
      }

      function wireProductInteractions() {
        // Continue Shopping button — closes the modal. Lives inside
        // body.innerHTML which is re-rendered each open, so the init-time
        // close-handler scan in modal.querySelectorAll() misses it.
        // Re-attach here for every freshly rendered product.
        body.querySelectorAll('[data-foam-qv-close]').forEach(function(el) {
          el.addEventListener('click', closeModal);
        });

        // Thumbnail click → swap main image
        body.querySelectorAll('[data-foam-qv-thumb]').forEach(function(t) {
          t.addEventListener('click', function() {
            var src = t.getAttribute('data-foam-qv-thumb');
            var mainImg = body.querySelector('[data-foam-qv-main-img] img');
            if (mainImg) mainImg.src = src;
            body.querySelectorAll('[data-foam-qv-thumb]').forEach(function(tt) { tt.classList.remove('is-active'); });
            t.classList.add('is-active');
          });
        });

        // Swatch click → update currentVariant, refresh price/availability/main img
        body.querySelectorAll('[data-foam-qv-option-index]').forEach(function(group) {
          var optIndex = parseInt(group.getAttribute('data-foam-qv-option-index'), 10);
          group.querySelectorAll('.foam-qv__swatch').forEach(function(sw) {
            sw.addEventListener('click', function() {
              var val = sw.getAttribute('data-foam-qv-value');
              // Build the new selection by pulling current active value from each option group
              var selection = [];
              body.querySelectorAll('[data-foam-qv-option-index]').forEach(function(g) {
                var i = parseInt(g.getAttribute('data-foam-qv-option-index'), 10);
                if (i === optIndex) {
                  selection[i] = val;
                } else {
                  var active = g.querySelector('.is-active');
                  selection[i] = active ? active.getAttribute('data-foam-qv-value') : null;
                }
              });
              // Find variant matching selection (treating null in selection as wildcard)
              var match = currentProduct.variants.find(function(v) {
                return v.options.every(function(o, i) { return selection[i] == null || selection[i] === o; });
              });
              if (!match) return;
              currentVariant = match;
              // Update active states for THIS option group only
              group.querySelectorAll('.foam-qv__swatch').forEach(function(s) { s.classList.remove('is-active'); });
              sw.classList.add('is-active');
              // Update price + add button availability
              var priceEl = body.querySelector('[data-foam-qv-price]');
              if (priceEl) priceEl.innerHTML = formatMoney(currentVariant.price) + '<span class="foam-qv__price-shipping">Free Shipping</span>';
              var addBtn = body.querySelector('[data-foam-qv-add]');
              if (addBtn) {
                addBtn.disabled = !currentVariant.available;
                addBtn.textContent = currentVariant.available ? 'Add to Bag →' : 'Sold Out';
              }
              // Swap main image if variant has its own
              if (currentVariant.featured_image && currentVariant.featured_image.src) {
                var mainImg = body.querySelector('[data-foam-qv-main-img] img');
                if (mainImg) mainImg.src = currentVariant.featured_image.src;
              }
            });
          });
        });

        // Add to Cart click
        var addBtn = body.querySelector('[data-foam-qv-add]');
        if (addBtn) {
          addBtn.addEventListener('click', function() {
            if (!currentVariant || !currentVariant.available || addBtn.classList.contains('is-loading')) return;
            addBtn.classList.add('is-loading');
            addBtn.textContent = 'Adding…';

            // Build cart-add payload. Include sections so cart-notification has updated content to render.
            // Detect whichever cart UI is active in this theme — drawer
            // takes precedence (we just flipped cart_type), notification
            // is the fallback. Either way we ask it for sections to fetch
            // so the response payload contains updated rendered markup.
            var cartUi = document.querySelector('cart-drawer')
                       || document.getElementById('cart-notification')
                       || document.querySelector('cart-notification');
            var sectionsToFetch = [];
            if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
              sectionsToFetch = cartUi.getSectionsToRender().map(function(s) { return s.section; });
            }

            var formData = {
              items: [{ id: currentVariant.id, quantity: 1 }]
            };
            if (sectionsToFetch.length) {
              formData.sections = sectionsToFetch.join(',');
              formData.sections_url = window.location.pathname;
            }

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
              body: JSON.stringify(formData)
            })
            .then(function(r) {
              if (!r.ok) throw new Error('Cart add failed');
              return r.json();
            })
            .then(function(data) {
              addBtn.classList.remove('is-loading');
              addBtn.textContent = 'Added ✓';
              // Hand off to whichever Dawn cart UI is rendered. Both expose
              // renderContents(parsedState) — drawer opens the slide-in,
              // notification pops the toast.
              if (cartUi && typeof cartUi.renderContents === 'function') {
                try {
                  cartUi.renderContents(data);
                } catch (e) {
                  console.warn('Cart UI render failed:', e);
                }
              }
              // Force-update the cart count bubble if Dawn ships one
              var cartIcons = document.querySelectorAll('cart-icon-bubble, [data-cart-count]');
              cartIcons.forEach(function(el) {
                if (el.classList) el.classList.remove('hidden');
              });
              // Close modal after a brief moment so user sees confirmation
              setTimeout(function() {
                closeModal();
                addBtn.textContent = 'Add to Bag →';
              }, 600);
            })
            .catch(function(err) {
              addBtn.classList.remove('is-loading');
              addBtn.textContent = 'Try again';
              setTimeout(function() { addBtn.textContent = 'Add to Bag →'; }, 2000);
              console.error('Quick view cart add error:', err);
            });
          });
        }

        // Buy with Shop button — Shopify's Shop Pay dynamic checkout
        // requires a real <product-form> element in the DOM, which we don't
        // have here. As a pragmatic fallback we add the variant to cart
        // first, then route to Shop Pay's accelerated checkout via
        // /checkout?payment=shop_pay. The user's session carries the cart.
        var shopPayBtn = body.querySelector('[data-foam-qv-shop-pay]');
        if (shopPayBtn) {
          shopPayBtn.addEventListener('click', function() {
            if (!currentVariant || !currentVariant.available) return;
            shopPayBtn.disabled = true;
            shopPayBtn.textContent = 'Loading…';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
              body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: 1 }] })
            })
            .then(function(r) {
              if (!r.ok) throw new Error('Add failed');
              window.location.href = '/checkout';
            })
            .catch(function(err) {
              shopPayBtn.disabled = false;
              shopPayBtn.innerHTML = 'Buy with <span class="foam-qv__shop-pay-logo">shop</span>';
              console.error('Shop pay add error:', err);
            });
          });
        }
      }

      // Close handlers — backdrop, X button, Escape key
      modal.querySelectorAll('[data-foam-qv-close]').forEach(function(el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });

      // Wire up trigger buttons (cards)
      document.querySelectorAll('[data-foam-qv-handle]').forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var handle = trigger.getAttribute('data-foam-qv-handle');
          var preferredVariant = trigger.getAttribute('data-foam-qv-variant');
          if (!handle) return;
          openModal();
          fetch('/products/' + encodeURIComponent(handle) + '.js', {
            headers: { 'Accept': 'application/json' }
          })
          .then(function(r) {
            if (!r.ok) throw new Error('Product fetch failed');
            return r.json();
          })
          .then(function(product) {
            renderProduct(product, preferredVariant);
          })
          .catch(function(err) {
            showError('Sorry, we couldn\'t load this product. Please try again.');
            console.error('Quick view fetch error:', err);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
